// extracted by mini-css-extract-plugin
export const tagsSection = "tagsSection-module--tagsSection--10wve";
export const tagContent = "tagsSection-module--tagContent--3TY2S";
export const current = "tagsSection-module--current--3DF4J";